export default __webpack_public_path__ + "static/media/water-treatment.8d990103.jpg";